import { render, staticRenderFns } from "./new-dashboard-banner.vue?vue&type=template&id=4d8ce07c&scoped=true&"
import script from "./new-dashboard-banner.vue?vue&type=script&lang=js&"
export * from "./new-dashboard-banner.vue?vue&type=script&lang=js&"
import style0 from "./new-dashboard-banner.vue?vue&type=style&index=0&id=4d8ce07c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8ce07c",
  null
  
)

export default component.exports